import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, Grid, makeStyles,
  MenuItem, TextField,
  Typography
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  textField: {
    width: "100%",
    "& + & ": {
      marginTop: theme.spacing(1.5),
    },
  },
}));

export default function FormOnEditListGroup(props) {
  const classes = useStyles();
  const { open, handleClose, editData, fetchAPI, stateOption } = props;
  const { handleSubmit, errors } = useForm();
  const [onError, setOnError] = useState(true);
  const [editDatas, setEditDatas] = useState({
    id: "",
    nama_user: "",
    idlayanan: "",
    idgroup: "",
  });

  const { nama_user, idlayanan, idgroup } = editDatas;

  const onSubmit = async () => {
    await fetchAPI("edit", editDatas);
  };

  useEffect(() => {
    if (
      editData?.nama_user === editDatas?.nama_user &&
      editData?.idlayanan === editDatas?.idlayanan &&
      editData?.idgroup === editDatas?.idgroup
    ) {
      return setOnError(true);
    }
    return setOnError(false);
  }, [editData, editDatas, onError]);


  useEffect(() => {
    if (editData) {
      setEditDatas({
        id: editData.id,
        nama_user: editData.nama_user,
        idlayanan: editData.idlayanan,
        idgroup: editData.idgroup,
      });
    }
  }, [editData]);

  const handleFieldChange = (e) =>
    setEditDatas({ ...editDatas, [e.target.name]: e.target.value });

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle id="form-dialog-title">Edit On List Group</DialogTitle>
          <DialogContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <TextField
                  disabled
                  id="nama_user"
                  name="nama_user"
                  value={nama_user}
                  label="Nama User"
                  type="string"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  select
                  className={classes.textField}
                  label="Layanan"
                  id="idlayanan"
                  name="idlayanan"
                  defaultValue={idlayanan}
                  fullWidth
                  onChange={handleFieldChange}
                  variant="outlined"
                  required
                >
                  <MenuItem value="none" disabled selected>
                    --Pilih Layanan--
                  </MenuItem>
                  {stateOption.option1 &&
                    stateOption.option1.map((item, i) => (
                      <MenuItem key={i} value={item.id}>
                        {item.nama}
                      </MenuItem>
                    ))}
                </TextField>
                {errors.idlayanan && (
                  <Typography variant="caption" color="error">{errors.idlayanan.message}</Typography>
                )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  select
                  className={classes.textField}
                  label="Nama Group"
                  id="idgroup"
                  name="idgroup"
                  defaultValue={idgroup}
                  fullWidth
                  onChange={handleFieldChange}
                  variant="outlined"
                  required
                >
                  <MenuItem value="none" disabled selected>
                    --Pilih Group--
                  </MenuItem>
                  {stateOption.option2 &&
                    stateOption.option2.map((item, i) => (
                      <MenuItem key={i} value={item.id}>
                        {item.nama}
                      </MenuItem>
                    ))}
                </TextField>
                {errors.idgroup && (
                  <Typography variant="caption" color="error">{errors.idgroup.message}</Typography>
                )}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button type="submit" color="primary" disabled={onError}>
              Save
            </Button>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
